enum PhoneContactType {
	HOME = 'Home',
	MOBILE = 'Mobile',
}

export default PhoneContactType;